<section class="col-12 cil-creation">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Créer votre Carnet d'Information Logement</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="creationForm">
        <mat-radio-group formControlName="creationType" class="radio-group">
          <app-radio [label]="'Une ' + ('enum.PropertyBookletType.BUILDING' | translate)" [value]="'BUILDING'"
            [hasContent]="true">
            <div content>Créez un CIL pour un bien qui vient d'être construit</div>
          </app-radio>
          <app-radio [label]="'Une ' + ('enum.PropertyBookletType.RENOVATION' | translate)" [value]="'RENOVATION'"
            [hasContent]="true" [hasBottom]="false">
            <div content>Créez un CIL après rénovation. Vous pouvez le créer même si ce bien n'as pas de CIL dans le
              cadre d'une construction neuve</div>
            <!-- @if (form_creationType.value===PropertyBookletType.RENOVATION) {
            <div bottom>
              <mat-label>Type de travaux effectués :</mat-label>
              <app-select label="Types de travaux" [formControl]="form_renovationWorkTypes" [list]="renovationWorkTypeList"
                [useLabelTranslation]="true" [isEnum]="true" enumName="PropertyBookletRenovationWorkType" size="12"
                [isMultiple]="true"></app-select>
            </div>
            } -->
          </app-radio>
        </mat-radio-group>
        <div [appTooltip]="createTooltip">
          <button mat-flat-button class="m-2" color="primary" (click)="confirmCreateBooklet()" [disabled]="loading"
            [disabled]="!canUpdateProperty">
            <ng-container *ngIf="!loading; else loadingSpinner">Créer</ng-container></button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</section>
<ng-template #loadingSpinner>
  <mat-icon>
    <mat-spinner diameter="20">
    </mat-spinner>
  </mat-icon>
</ng-template>